const baseURL = import.meta.env.VITE_APP_API_BASE_URL

const API = {
  TOKEN: {
    ACCESS: `${baseURL}api/token/`,
    REFRESH: `${baseURL}api/token/refresh/`
  },
  ROLES: {
    INDEX: `${baseURL}roles/`
  },
  CORE: {
    PROJECTS: {
      INDEX: `${baseURL}projects/`
    },
    PROJECT_USERS: {
      INDEX: `${baseURL}project_users/`
    },
    USERS: {
      INDEX: `${baseURL}core/users/`,
      CURRENT_USER: `${baseURL}core/users/current_user/`
    }
  },
  SPECKLE: {
    BASE: `${baseURL}core/speckle/`
  },
  OPENGROUND: {
    EXPORT_OPENGROUND_TO_SPECKLE: `${baseURL}gi_data/openground/export_to_speckle/`,
    TASK_STATUS: (taskId: string) => `${baseURL}gi_data/openground/task-status/${taskId}/`,
    GI_LOCATIONS: `${baseURL}gi_data/openground/gi_locations/`,
    PROJECT_METADATA: `${baseURL}gi_data/openground/project_metadata/`,
    ACCESS_TOKEN: `${baseURL}gi_data/openground/access_token/`
  }
}

export default API
